const bankList = {
  '100': '邮政储蓄银行',
  '102': '中国工商银行',
  '103': '中国农业银行',
  '104': '中国银行',
  '105': '中国建设银行',
  '301': '交通银行',
  '302': '浦发银行',
  '303': '光大银行',
  '304': '华夏银行',
  '305': '民生银行',
  '306': '广发银行',
  '308': '招商银行',
  '309': '兴业银行',
  '310': '浦发银行',
  '410': '平安银行'
}

export default bankList



// WEBPACK FOOTER //
// ./src/utils/bank.js